import { __assign } from "tslib";
import { toggleChildrenState } from './toggle-children-state';
/**
 * 切换节点状态
 * @param node 节点
 * @param checked 是否选中
 * @returns 切换后的节点
 */
export function toggleNode(node, checked) {
    // 父节点选中，子节点全部选中
    return __assign(__assign({}, node), { checked: checked, indeterminate: false, children: toggleChildrenState(node.children, checked) });
}
